import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('latest-section', {

    data() {
        return {
        };
    },

    mounted() {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= 1024) {
            //this.initSection();
        }
    },

    methods: {
        initSection() {
            ScrollTrigger.create({
                trigger: '.home__work-container',
                pin: '.home__work-container',
                start: 'top center',
            });
        },
    },
});